"use client";

import { Icon } from "@/components/ui/icon";

import { importableStages, type ImportStage } from "./import-stage";

export type ProfileImportStageFieldProps = {
  stages: ImportStage[];
  value: string;
  onChange: (stageId: string) => void;
  disabled?: boolean;
  id?: string;
};

export function ProfileImportStageField({
  stages,
  value,
  onChange,
  disabled = false,
  id = "profile-import-stage",
}: ProfileImportStageFieldProps) {
  const options = importableStages(stages);

  return (
    <section className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-sm font-medium text-heading leading-5"
      >
        Choose the stage to add these imported profiles to
      </label>
      <p className="text-sm text-contrast/60 leading-normal">
        All imported profiles will be added to the below selected stage.
      </p>
      <div className="relative mt-1">
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled || options.length === 0}
          className="block h-9 w-full cursor-pointer appearance-none rounded-md border border-contrast/15 bg-contrast/6 pl-9 pr-8 text-sm text-heading shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] focus:outline-none disabled:cursor-not-allowed disabled:opacity-60"
        >
          {options.map((s) => (
            <option
              key={s.id}
              value={s.id}
              className="bg-surface-elevated text-heading"
            >
              {s.name}
            </option>
          ))}
        </select>
        <Icon
          name="IconPlan"
          size={16}
          className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-heading opacity-70"
        />
        <Icon
          name="IconArrowBottomTop"
          size={14}
          className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-heading opacity-50"
        />
      </div>
    </section>
  );
}
